<template>
  <div>
    <loading v-if="validateToken"></loading>
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import loading from './views/templates/loading.vue'
  import { userCart, userKey, api} from '@/global'
export default {
  name: 'App',
  components: {
    loading
  },
  data() {
    return {
      validateToken: true
    }
  },
  created() {
    this.verificationToken()
  },
  methods: {
    async verificationToken() {
      this.validateToken = true

      const json = localStorage.getItem(userKey)
      const userData = JSON.parse(json)
      this.$store.commit('setUser', null)

      if(!userData){
        this.validateToken = false
        this.$router.push({ name: 'Login' });
        return
      }

      api.defaults.headers.Authorization = userData.token;
      await api.post('/customer/validateToken')
      .then(response => {
        delete api.defaults.headers.Authorization
        this.$store.commit('setUser', userData)
        this.$store.dispatch('loadCartUser')
      })
      .catch(error => {
        localStorage.removeItem(userKey)
        localStorage.removeItem(userCart)
        this.$router.push({ name: 'Login' });
      })
      setTimeout(() => {
        this.validateToken = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
